import React, { ReactNode, useState } from "react";
import { Button, chakra, Text } from "@chakra-ui/react";
import usePostWork from "../../hooks/usePostWork";
import PostModal from "./PostModal";
import Icon from "@/components/Icon";
import { ReactComponent as ShareIcon } from "@/assets/icons/share.svg";
import { Editor_Words } from "@/utils/lang/editor";
import { useTranslate } from "@/utils/lang";
import { observer } from "mobx-react-lite";
import { useOwnToast } from "@/utils/misc";
import { WithClassName } from "@/types/base";

const PostWork: React.FC<
  WithClassName<{
    buttonType?: "outline" | "primary";
    children?: ReactNode;
  }>
> = ({ buttonType = "primary", className, children }) => {
  const { translate } = useTranslate();
  const toast = useOwnToast();

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const postWorkData = usePostWork();

  function handleClick() {
    if (postWorkData.msg) {
      toast({
        status: "warning",
        title: postWorkData.msg,
        isClosable: true,
        position: "top",
      });
    }
    if (postWorkData?.continue) {
      setOpen(true);
    }
  }
  return (
    <>
      <Button w="100%" variant={buttonType} onClick={handleClick} className={className}>
        {children || (
          <>
            <Icon svg={ShareIcon} fillbyCurrentColor fontSize="18px" />
            <Text ml="8px">{translate(Editor_Words["post-to-gallery"])}</Text>
            {postWorkData.imageNodes?.length > 0 ? `(${postWorkData.imageNodes?.length})` : ""}
          </>
        )}
      </Button>
      <PostModal open={open} onClose={handleClose} data={postWorkData} />
    </>
  );
};

export default chakra(observer(PostWork));
